import React, { Suspense } from 'react'

import { useTranslation } from 'react-i18next'
import { Await, useLoaderData, useNavigation } from 'react-router-dom'

import LoadingMessage from '@components/LoadingMessage'
import FavoritesView from '@components/myScores/FavoritesView'
import LoadingSpinner from '@components/shared/LoadingSpinner'
import { FavoritesLoaderResponse } from '@pages/home/loaders/favorites.loader'
import { usePageTitle } from '@providers/LayoutProvider'

const FavoriteScoresPage: React.FC = () => {
  const { t } = useTranslation()
  const data = useLoaderData() as FavoritesLoaderResponse
  const navigation = useNavigation()

  usePageTitle(t('titles.favoriteScores'))

  const isReloading =
    navigation.state === 'loading' &&
    navigation.formData != null &&
    navigation.location.pathname === '/home/favorites'

  return (
    <>
      {isReloading && <LoadingMessage />}
      <Suspense
        fallback={
          <>
            {/* Spacer */}
            <div className="h-16 w-full" />

            <LoadingSpinner />
          </>
        }>
        <Await resolve={data.favoriteScores}>
          {(favoriteScoresResp) => (
            <FavoritesView initialData={favoriteScoresResp} order={data.order} />
          )}
        </Await>
      </Suspense>
    </>
  )
}

export default FavoriteScoresPage
